import { z } from 'zod';
import i18n from '@/i18n';

export const registrationStepAboutAndTravelPlansSchema = z.object({
    about_me:
        z
            .string()
            .trim()
            // @ts-ignore
            .min(1, i18n.t('desc_required'))
            // @ts-ignore
            .max(255, i18n.t('desc_max_len', { len: 300 })),
    travel_plans:
        z
            .string()
            // @ts-ignore
            .min(1, i18n.t('field_must_not_be_empty'))
            // @ts-ignore
            .max(500, i18n.t('desc_required')),
});

export type RegistrationStepAboutAndTravelPlansType = z.infer<typeof registrationStepAboutAndTravelPlansSchema>;
